export const IDENTITY_VERIFICATION_REQUIREMENT_INSTRUCTIONS = `
##### What You'll Need

1. **A government-issued ID document**
   
   We accept the following types of identification:
   - Driver's License
   - State or Provincial ID
   - Passport
   - Passport Card
   - Visa
   - Permanent Residence Card (Green Card)
   - Work Permit (EAD Card)
   - Other government-issued IDs from 200+ countries

##### Verification Steps

1. **Scan a QR code or click the verification link**
   - You'll be directed to our secure verification experience
   - No app download required

2. **Capture your ID document**
   - Position your ID within the frame for automatic capture
   - Some documents require photos of both front and back
   - Our technology ensures clear, readable images

3. **Take a selfie for identity confirmation**
   - Remove glasses, hats, or face coverings if possible
   - Ensure good lighting on your face
   - Look directly at the camera
   - Your selfie will be matched with the photo on your ID

##### Tips for Success

- Use a well-lit area for both ID and selfie capture
- Ensure your ID is not expired
- Hold your ID flat and avoid glare
- Keep a neutral expression for your selfie
- Make sure your entire face is visible in the selfie

The entire process typically takes less than 2 minutes to complete.
`;
